<div class="mode-switcher">
  @for (_mode of modes; track _mode) {
    <button
      appButton
      [attr.name]="'mode-' + _mode.key | replace: ' ' : '-'"
      [name]="'mode-' + _mode.key | replace: ' ' : '-'"
      [location]="location"
      height="1"
      shape="round"
      weight="bold"
      [color]="mode === _mode.key ? 'simple-primary constant' : 'simple'"
      (click)="modeChange.emit(_mode.key)"
    >
      {{ _mode.text }}
    </button>
  }
</div>
